import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { REQUESTS_BASE_URL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationAddedSubject = new Subject<void>();
  public notificationAdded$ = this.notificationAddedSubject.asObservable();

  constructor(
    private http: HttpClient, 
  ) {}

  getNotificationList(from: number, size : number){
    return this.http.get(
      `${REQUESTS_BASE_URL}/api/notification-manager/client-api/v1/getAllNotifications?from=${from}&size=${size}`
    )
  }

  searchNotificationList(from: number, size : number, key:string){
    const encodedKey = encodeURIComponent(key)
    return this.http.get(
      `${REQUESTS_BASE_URL}/api/notification-manager/client-api/v1/notification/search?from=${from}&size=${size}&key=${encodedKey}`
    )
  }

  triggerNotificationRefresh(): void {
    this.notificationAddedSubject.next();
  }
}
